import React from 'react'
import { Form } from 'react-bootstrap'

type ConsentCommentInputProps = {
  required?: boolean
  value: string
  onChange: (value: string) => void
}

export const ConsentCommentInput: React.FC<ConsentCommentInputProps> = ({ required = false, value, onChange }) => {
  const labelText = `Comment ${required ? '' : '(optional)'}`

  return (
    <div className='d-flex gap-4 align-items-start'>
      <div className='d-flex align-items-center flex-shrink-0'>
        <span className='paragraph-medium zocks-text-gray-900'>{labelText}</span>
      </div>
      <div className='flex-grow-1 zocks-bg-color-gray-100 rounded-2 p-3'>
        <Form.Control
          as='textarea'
          rows={8}
          className='border rounded-2'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={'Add Comment'}
        />
      </div>
    </div>
  )
}
